import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { useSortable } from '@dnd-kit/sortable';
import { animateLayoutChanges } from '../utils';
import { ContainerPropsI } from '../types';
import { H4 } from '@osmosis/react-ui/components/Text';

/**
 * Container.
 */
export const Container = ({
  children,
  id,
  items,
  sx,
  listsSx,
  headerSx,
  wrapperSx,
}: ContainerPropsI) => {
  const { setNodeRef } = useSortable({
    id,
    data: {
      type: 'container',
      children: items,
    },
    animateLayoutChanges,
  });

  const listsSxWithoutAfter = {
    ...listsSx,
    ':after': {
      display: 'none',
    },
  };

  return (
    <Box sx={wrapperSx}>
      <H4 sx={headerSx}>{id}</H4>
      <Box ref={setNodeRef} sx={sx}>
        <Box as="ul" sx={items?.length ? listsSxWithoutAfter : listsSx}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
